/**
 * Accede a una propiedad anidada de un objeto usando una key en formato string (ej: 'a.b.c')
 */
export function getNestedValue(obj, key) {
    return key.split('.').reduce((o, i) => o?.[i], obj);
}
